'use client';

import { GlobeContextualPopup } from '@/features/globe';
import { SiteFooter } from '@/site/SiteFooter/SiteFooter';
import { VitalsPopup } from '@/features/vitals';
import { Salutation, ScrollHint, WorkLifeToggle } from '@/features/landing';
import { useSkyShell } from '@/features/sky';
import { StickyPulse } from '@/features/pulse';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { useRef, useState } from 'react';
import styles from './layout.module.css';

export default function LandingLayout({ children }: { children: ReactNode }) {
  const { setSkyState } = useSkyShell();

  const pathname = usePathname();
  const isLife = pathname?.startsWith('/life') ?? false;

  const [connected, setConnected] = useState(false);

  const pulseSlotRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.scroll}>
      <div className={styles.heroForeground}>
        <div className={styles.innerLayout}>
          <Salutation
            shell={isLife ? 'life' : 'work'}
            pulseSlotRef={pulseSlotRef}
            nav={<WorkLifeToggle />}
          />
          <StickyPulse
            slotRef={pulseSlotRef}
            variant={isLife ? 'life' : 'build'}
          />
        </div>

        <div className={styles.indicatorsContainer}>
          <div className={styles.globeSlot}>
            <GlobeContextualPopup
              onConnected={() => setConnected(true)}
              onOpenChange={(open) => setSkyState({ cloudsClear: open })}
            />
          </div>

          <div
            className={styles.heartRateSlot}
            style={{ opacity: connected ? 1 : 0 }}
          >
            <VitalsPopup />
          </div>
        </div>

        <ScrollHint />
      </div>

      {children}

      <SiteFooter compass={true} />
    </div>
  );
}
